import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ru from './locales/ru.json';
import ky from './locales/ky.json';
import en from './locales/en.json';

const savedLng =
    typeof window !== 'undefined' ? (localStorage.getItem('lng') || undefined) : undefined;

i18n
    .use(initReactI18next)
    .init({
        resources: {
            ru: { translation: ru },
            ky: { translation: ky },
            en: { translation: en },
        },
        lng: savedLng || 'ru',   // язык по умолчанию или сохранённый
        fallbackLng: 'ru',
        interpolation: { escapeValue: false },
    });

export default i18n;
